import React from 'react';
import { useTranslate } from 'react-admin';

import { VeenguLogoIcon, VeenguLogoFull } from '~/img';
import { useStyles } from '~/hooks/useLayoutMenuStyles';
import { useTenant } from '~/hooks/tenant';
import { l } from '~/types/layoutMenu';
import { BUILD_VERSION } from '~/env';

const MenuFooter = ({ open }: { open: boolean }) => {
  const classes = useStyles({});
  const translate = useTranslate();
  const t = (key: string, options?: any): string => translate(l(key), options);
  const { data: tenant } = useTenant();
  const backendVersion = tenant?.backend?.version;
  return (
    <div className={classes.footer}>
      <div className={`${classes.footerLogo}${!open ? ` ${classes.footerLogoRail}` : ''}`}>
        {open ? (
          <VeenguLogoFull className={classes.footerLogoFull} />
        ) : (
          <VeenguLogoIcon className={classes.footerLogoIcon} />
        )}
      </div>
      {open && (
        <div className={classes.footerText}>
          <div>
            {t('core')} <strong>v{backendVersion}</strong>
          </div>
          <div>
            {t('dashboard')} <strong>v{BUILD_VERSION}</strong>
          </div>
        </div>
      )}
    </div>
  );
};

export default MenuFooter;
